@if (paramMap$ | async; as paramMap) {
	<article class="error-page">
		<div class="wrapper">
			<span class="h5 title">{{ getTitleKey(paramMap) | translate }}</span>
			<div class="error" translate="{{ getMessageKey(paramMap) }}"></div>
			@if (isReportFormAvailable(paramMap)) {
				<div>
					<button
						class="sm"
						[routerLink]="[
							'..',
							'errorReport',
							{
								errorType: paramMap.get('errorType'),
								incidentId: paramMap.get('incidentId'),
								isReportable: paramMap.get('isReportable'),
								isTemporary: paramMap.get('isTemporary'),
							},
						]"
					>
						{{ "error.report.message" | translate }}
					</button>
				</div>
			}
			@if (isSupportInfoAvailable(paramMap)) {
				<div>
					<a href="app/supportinfo" target="_self"
						><button class="sm">{{ "error.downloadSupportinfo.message.part1" | translate }}</button></a
					>
					<a
						href="mailto:{{ supportEmailAddress }}?subject=[Incident ID {{ paramMap.get('incidentId') }}]&body={{
							'error.report.placeholder' | translate
						}}"
						><button class="sm">{{ "error.downloadSupportinfo.message.part2" | translate }}</button></a
					>
				</div>
			}
			@if (isLinkToHomeAvailable(paramMap)) {
				<div>
					<button class="sm" [ngClass]="getHomeButtonClasses(paramMap)" (click)="goHome()">
						{{ "error.goHome" | translate }}
					</button>
				</div>
			}
			@if (isRetryAvailable(paramMap)) {
				<div>
					<button class="sm" (click)="retry()">{{ "error.retry" | translate }}</button>
				</div>
			}
		</div>
	</article>
}
